<template>
  <div>
    <HeaderBar>
      <v-icon slot="icon">device_hub</v-icon>
      Manager Users
      <template slot="buttons">
        <v-btn @click="addManagerDialogOpen = true" color="success">
          <v-icon left>
            add
          </v-icon>
          Add Manager User
        </v-btn>
      </template>
    </HeaderBar>

    <v-layout row>
      <v-flex v-if="gettingManagers">
        <v-progress-linear indeterminate> </v-progress-linear>
      </v-flex>
      <v-flex v-else>
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            >
            </v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="filteredManagers"
            item-key="id"
            :search="search"
            :pagination.sync="defaultSort"
            class="elevation-1"
          >
            <template slot="items" slot-scope="{ item }">
              <tr @click="openManager(item)">
                <td :class="deactivated(item) ? 'subtle' : ''">
                  {{ item.name }}
                </td>
                <td :class="deactivated(item) ? 'subtle strikethrough' : ''">
                  {{ item.email }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="addManagerDialogOpen">
      <v-card>
        <v-card-title class="headline">Add Manager</v-card-title>

        <v-card-text>
          <v-form>
            <v-text-field label="First Name" v-model="newManager.firstName" />
            <v-text-field label="Last Name" v-model="newManager.lastName" />
            <v-text-field label="Email" v-model="newManager.email" />
          </v-form>
          <p class="caption">
            Be sure to initiate a password reset email after creating this
            manager user.
          </p>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" flat @click="addManagerDialogOpen = false"
            >Nevermind</v-btn
          >
          <v-btn
            color="success"
            :loading="managerAddPending"
            @click="saveManager"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EmployeeName from "@/components/hr/employee-name.vue";
import HeaderBar from "@/components/base/header-bar.vue";
import collectionsApi from "@/api/collections";

export default {
  components: {
    EmployeeName,
    HeaderBar
  },
  created() {
    this.setUp();
  },
  watch: {},
  computed: {
    ...mapState("userAuth", ["user"]),
    // ...mapState('managers', [
    //   'managers',
    // ]),
    ...mapState("hr", ["filters"]),
    filteredManagers: function() {
      var filtered = this.managers;

      if (this.selectedManagerFilter) {
        filtered = filtered.filter(client => {
          if (
            client.clientLocations
              .map(l => l.manager_id)
              .includes(this.selectedManagerFilter.id)
          ) {
            return client;
          }
        });
      }

      return filtered;
    }
  },
  methods: {
    resetFilters() {},
    openManager(manager) {
      this.$router.push({
        name: "hrManagerDetail",
        params: { managerId: manager.id }
      });
    },
    setUp() {
      this.getManagers();
    },

    deactivated(manager) {
      return manager.deactivated;
    },

    getManagers() {
      this.gettingManagers = true;
      this.$store
        .dispatch("managers/getAll")
        .then(managers => {
          this.managers = managers;
        })
        .finally(res => {
          this.gettingManagers = false;
        });
    },

    saveManager() {
      this.$store
        .dispatch("managers/createManager", this.newManager)
        .finally(r => {
          this.managerAddPending = false;
          this.addManagerDialogOpen = false;
          this.getManagers();
        });
    }
  },
  data: function() {
    return {
      addManagerDialogOpen: false,
      managerAddPending: false,
      gettingManagers: false,
      managers: [],
      search: "",
      newManager: {
        firstName: "",
        lastName: "",
        email: ""
      },
      defaultSort: {
        sortBy: "deactivated",
        ascending: true,
        rowsPerPage: 10
      },
      headers: [
        { text: "Name", value: "name" },
        { text: "Email", value: "email" }
      ]
    };
  }
};
</script>

<style scoped>
.strikethrough {
  text-decoration: line-through;
}
</style>
